import React from 'react'
import { useNavigate } from 'react-router-dom'

import { useApolloClient } from '@apollo/client'
import { CalendarPageQueryDocument } from 'generated/resources/graphql'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { useCalendarLeaves } from 'modules/calendar/hooks/useCalendarLeaves'
import contractVersions from 'modules/contracts/store/collections/contractVersions'
import EditLeave from 'modules/timeoff/components/EditLeave'
import LeaveRecommendationModal from 'modules/timeoff/components/LeaveRecommendationModal'
import { useLeaveRecommendationFeatureFlag } from 'modules/timeoff/hooks/useLeaveRecommendationFeatureFlag'
import { useOnCloseTeamView } from 'modules/timeoff/hooks/useOnCloseTeamView'

const TeamViewEditLeavePage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const { leave_id: leaveId, year } = useStrictParams<'leave_id' | 'year'>()

  const onReject = () => {
    if (leaveId) {
      navigate(navigation.calendar.teamView.leavesRejectLeaveId.fullPath({ leave_id: leaveId }))
    }
  }

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )
  const apolloClient = useApolloClient()

  const onClose = useOnCloseTeamView()
  const { onChangeLeave } = useCalendarLeaves()

  const { loading: ffLoading, enabled: isRecommendationEnabled } =
    useLeaveRecommendationFeatureFlag()

  const showRecommendationModal = !ffLoading && isRecommendationEnabled

  const handleClose = () => {
    apolloClient.refetchQueries({
      include: [CalendarPageQueryDocument],
    })
    onChangeLeave()
    onClose()
  }
  if (leaveId === undefined) return null

  return (
    <>
      {showRecommendationModal ? (
        <LeaveRecommendationModal
          leaveYear={Number(year)}
          leaveId={Number(leaveId)}
          onClose={handleClose}
          onChange={handleClose}
          onReject={onReject}
          fromCalendar
          contractVersions={contractVersions}
          loading={loading}
        />
      ) : (
        <EditLeave
          leaveYear={Number(year)}
          leaveId={Number(leaveId)}
          onClose={onClose}
          onChange={onChangeLeave}
          onReject={onReject}
          fromCalendar
          contractVersions={contractVersions}
          loading={loading}
        />
      )}
    </>
  )
}

export default TeamViewEditLeavePage
